(function () {
    if (window.__mnlGridCarousel) return;
    window.__mnlGridCarousel = true;

    let INTERVAL = 3000;
    let RESUME_DELAY = 0;
    let mq = window.matchMedia("(max-width: 768px)");

    /* ------- cached layout ------- */
    function getLayout(grid, items) {
        let gap = parseFloat(getComputedStyle(grid).columnGap) || 0;
        let w = items[0].getBoundingClientRect().width;
        return { gap: gap, w: w };
    }

    /* ------- dots ------- */
    function buildDots(grid, items) {
        if (items.length < 2) return null;
        let wrap = document.createElement("div");
        wrap.className = "mcarousel-dots";
        let dots = Array.from({ length: items.length }, function (_, i) {
            let btn = document.createElement("button");
            btn.className = "mcarousel-dot" + (i === 0 ? " is-active" : "");
            btn.setAttribute("aria-label", "Item " + (i + 1));
            btn.addEventListener("click", function () {
                let l = getLayout(grid, items);
                smoothTo(grid, i * (l.w + l.gap));
            });
            wrap.appendChild(btn);
            return btn;
        });
        grid.insertAdjacentElement("afterend", wrap);
        return dots;
    }

    function updateDots(dots, active) {
        if (!dots) return;
        dots.forEach(function (d, i) {
            d.classList.toggle("is-active", i === active);
        });
    }

    /* ------- scroll ------- */
    function smoothTo(grid, targetLeft) {
        let startLeft = grid.scrollLeft;
        let startTime = null;
        let duration = 500;
        function ease(t) {
            return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        }
        grid.style.scrollSnapType = "none";
        function frame(ts) {
            if (!startTime) startTime = ts;
            let p = Math.min((ts - startTime) / duration, 1);
            grid.scrollLeft = startLeft + (targetLeft - startLeft) * ease(p);
            if (p < 1) {
                requestAnimationFrame(frame);
            } else {
                grid.style.removeProperty("scroll-snap-type");
            }
        }
        requestAnimationFrame(frame);
    }

    /* ------- carousel ------- */
    function init(grid) {
        if (grid.dataset.mcarouselReady) return;
        grid.dataset.mcarouselReady = "1";

        // Custom item selector via data-carousel-item (e.g. reassurance uses .reassurance-item)
        let itemSel = grid.dataset.carouselItem || ".grid-product";
        let items = Array.from(grid.querySelectorAll(itemSel));

        if (!items.length) {
            // Grid exists but is empty (recently-viewed, product-recommendations) — wait for items
            delete grid.dataset.mcarouselReady;
            new MutationObserver(function (_, obs) {
                if (grid.querySelectorAll(itemSel).length) {
                    obs.disconnect();
                    init(grid);
                }
            }).observe(grid, { childList: true, subtree: true });
            return;
        }

        let dots = buildDots(grid, items);
        let timer = null;
        let idle = null;
        let scrollTimer;
        let layoutCache = null;

        window.addEventListener(
            "resize",
            function () {
                layoutCache = null;
            },
            { passive: true },
        );

        function layout() {
            if (!layoutCache) layoutCache = getLayout(grid, items);
            return layoutCache;
        }

        grid.addEventListener(
            "scroll",
            function () {
                clearTimeout(scrollTimer);
                scrollTimer = setTimeout(function () {
                    let l = layout();
                    let active = Math.round(grid.scrollLeft / (l.w + l.gap));
                    updateDots(dots, active);
                }, 60);
            },
            { passive: true },
        );

        function step() {
            let l = layout();
            let atEnd =
                grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 2;
            smoothTo(grid, atEnd ? 0 : grid.scrollLeft + l.w + l.gap);
        }

        function start() {
            if (timer || !mq.matches) return;
            timer = setInterval(step, INTERVAL);
        }
        function stop() {
            if (timer) {
                clearInterval(timer);
                timer = null;
            }
        }
        function pauseThenResume() {
            stop();
            clearTimeout(idle);
            idle = setTimeout(start, RESUME_DELAY);
        }

        ["pointerdown", "touchstart", "wheel"].forEach(function (ev) {
            grid.addEventListener(ev, pauseThenResume, { passive: true });
        });

        mq.addEventListener("change", function () {
            stop();
            start();
        });

        if (window.IntersectionObserver) {
            new IntersectionObserver(
                function (entries) {
                    entries[0].isIntersecting ? start() : stop();
                },
                { threshold: 0.1 },
            ).observe(grid);
        } else {
            start();
        }

        document.addEventListener("visibilitychange", function () {
            document.hidden ? stop() : start();
        });
    }

    function run() {
        document.querySelectorAll(".grid-manelli--mcarousel").forEach(init);
    }

    // Catch AJAX-injected grids (product-recommendations injects its grid after fetch)
    new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
            m.addedNodes.forEach(function (node) {
                if (node.nodeType !== 1) return;
                if (node.classList.contains("grid-manelli--mcarousel"))
                    init(node);
                node.querySelectorAll &&
                    node
                        .querySelectorAll(".grid-manelli--mcarousel")
                        .forEach(init);
            });
        });
    }).observe(document.body, { childList: true, subtree: true });

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", run);
    } else {
        run();
    }
})();
